/**
 * A stroke that draws itself.
 *
 * `stroke-dashoffset` on a path whose `pathLength` is normalised to 1, so the
 * caller never has to measure geometry — the same trick `DispatchPlate` uses in
 * the console's login screen, generalised.
 *
 * This one *may* animate from nothing, and it is the exception that proves the
 * rule: a path carries no text. Under reduced motion it renders fully drawn on
 * the first frame, which is the state that means "this connection exists".
 */
import { m } from 'motion/react'

import { useReducedMotionSafe } from './motion'

export function PathDraw({
  d,
  delay = 0,
  duration = 0.7,
  className,
  markerEnd,
}: {
  d: string
  delay?: number
  duration?: number
  className?: string
  markerEnd?: string
}) {
  const reduced = useReducedMotionSafe()

  if (reduced) {
    return (
      <path d={d} className={className} markerEnd={markerEnd} vectorEffect="non-scaling-stroke" />
    )
  }

  return (
    <m.path
      d={d}
      className={className}
      markerEnd={markerEnd}
      vectorEffect="non-scaling-stroke"
      pathLength={1}
      initial={{ strokeDasharray: 1, strokeDashoffset: 1 }}
      whileInView={{ strokeDashoffset: 0 }}
      viewport={{ once: true, margin: '-10%' }}
      transition={{ duration, delay, ease: 'easeInOut' }}
    />
  )
}
